// Shared by the AAA bet table and the virtual AAA view.
// main / fancy split like the reference (feed sub filtered by subtype, sorted by sr)
export function aaaMarkets(sub = []) {
  const list = (Array.isArray(sub) ? sub : []).filter(Boolean);
  const bySr = (a, b) => Number(a?.sr) - Number(b?.sr);
  const main = list.filter((s) => !String(s?.subtype || "").endsWith("fancy")).sort(bySr);
  const fancy = list.filter((s) => String(s?.subtype || "").endsWith("fancy")).sort(bySr);
  return { main, fancy };
}
